export default __webpack_public_path__ + "static/media/X035.20dba9ce.png";